import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=06b1af1d&scoped=true&"
import script from "./teacherList.vue?vue&type=script&lang=js&"
export * from "./teacherList.vue?vue&type=script&lang=js&"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=06b1af1d&prod&scoped=true&lang=scss&"
import style1 from "./teacherList.vue?vue&type=style&index=1&id=06b1af1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1af1d",
  null
  
)

export default component.exports